import { createContext, useContext } from "react";
import type { DraftDay } from "../utils/draftDay";
import type { DraftChange } from "../utils/models";

export type DraftModeContextType = {
	isDraftMode: boolean;
	draftChanges: DraftChange[];
	hasUnsavedChanges: boolean;
	/** The drafted day as it was when the draft began. */
	originalDay?: DraftDay;
	enableDraftMode: () => void;
	disableDraftMode: () => void;
	publishChanges: () => Promise<void>;
	discardChanges: () => void;
	isPublishing: boolean;
	locallyApprovedRequests: string[];
	isRequestLocallyApproved: (requestId: string) => boolean;
	/** The Day view's day as the draft has it: from the schedule cache with `staffing_schedule_cache` on, the old list off. */
	activeDayData?: DraftDay;
};

export const DraftModeContext = createContext<DraftModeContextType | undefined>(undefined);

export const useDraftMode = (): DraftModeContextType => {
	const context = useContext(DraftModeContext);
	if (!context) throw new Error("useDraftMode must be used within DraftModeProvider");

	return context;
};
